/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Consent_TextInputs */

const en_register_onboarding_personal_info_consent_text = /** @type {(inputs: Register_Onboarding_Personal_Info_Consent_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By uploading the file, I agree to the transmission of my resume, including my personal data, to the AI. I have read the`)
};

const de_register_onboarding_personal_info_consent_text = /** @type {(inputs: Register_Onboarding_Personal_Info_Consent_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit dem Hochladen der Datei stimme ich der Übermittlung meines Lebenslaufs einschließlich meiner personenbezogenen Daten an die KI zu. Ich habe die`)
};

/**
* | output |
* | --- |
* | "By uploading the file, I agree to the transmission of my resume, including my personal data, to the AI. I have read the" |
*
* @param {Register_Onboarding_Personal_Info_Consent_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_consent_text = /** @type {((inputs?: Register_Onboarding_Personal_Info_Consent_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Consent_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_consent_text(inputs)
	return en_register_onboarding_personal_info_consent_text(inputs)
});